import React from "react";
import { Container, Typography, Paper, Box, Grid, Card, CardContent } from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import InsightsIcon from "@mui/icons-material/Insights";
import ConstructionIcon from "@mui/icons-material/Construction";
import PsychologyIcon from "@mui/icons-material/Psychology";

const Analytics = () => {
  const plannedFeatures = [
    {
      icon: <SmartToyIcon sx={{ fontSize: 40, color: '#2196f3' }} />,
      title: "AI-анализ данных",
      description: "Искусственный интеллект для автоматического анализа трендов и закономерностей"
    },
    {
      icon: <AutoGraphIcon sx={{ fontSize: 40, color: '#4caf50' }} />,
      title: "Умные прогнозы",
      description: "Машинное обучение для предсказания продаж и оптимизации бизнес-процессов"
    },
    {
      icon: <InsightsIcon sx={{ fontSize: 40, color: '#ff9800' }} />,
      title: "Автоматические инсайты",
      description: "ИИ найдет скрытые закономерности и даст рекомендации для роста бизнеса"
    },
    {
      icon: <PsychologyIcon sx={{ fontSize: 40, color: '#9c27b0' }} />,
      title: "Анализ поведения",
      description: "Глубокий анализ поведения клиентов с помощью нейронных сетей"
    }
  ];

  return (
    <Container className="erp-planned-page" maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          mb: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          textAlign: "center",
          background: 'linear-gradient(135deg, #0878ff 0%, #244a77 100%)',
          color: 'white'
        }}
      >
        <ConstructionIcon
          sx={{
            fontSize: 80,
            mb: 3,
            opacity: 0.9
          }}
        />
        <Typography variant="h3" gutterBottom fontWeight="bold">
          🤖 AI-Аналитика
        </Typography>
        <Typography variant="h6" gutterBottom sx={{ opacity: 0.9 }}>
          Модуль в разработке
        </Typography>
        <Typography variant="body1" sx={{ mt: 2, maxWidth: 600, opacity: 0.8 }}>
          Революционный модуль искусственного интеллекта для глубокой аналитики данных. 
          Здесь будет подключен AI для автоматического анализа продаж, прогнозирования 
          и генерации бизнес-инсайтов на основе ваших данных.
        </Typography>
      </Paper>

      <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
        🧠 AI-возможности будущего
      </Typography>

      <Grid container spacing={3}>
        {plannedFeatures.map((feature, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4
                }
              }}
            >
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Box sx={{ mb: 2 }}>
                  {feature.icon}
                </Box>
                <Typography variant="h6" gutterBottom fontWeight="bold">
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Paper
        elevation={1}
        sx={{
          mt: 4,
          p: 3,
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          textAlign: 'center'
        }}
      >
        <Typography variant="h6" gutterBottom color="primary" fontWeight="bold">
          🚀 Будущее аналитики уже близко
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Мы работаем над интеграцией передовых технологий машинного обучения и 
          искусственного интеллекта для создания самой умной CRM-системы.
        </Typography>
        <Box component="ul" sx={{ textAlign: 'left', maxWidth: 600, mx: 'auto' }}>
          <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            🔮 Предсказание трендов продаж с точностью 95%
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            📊 Автоматическая сегментация клиентов по поведению
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            💡 Персонализированные рекомендации для каждого клиента
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            📈 Оптимизация ценообразования на основе данных
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            🎯 Автоматическое выявление рисков и возможностей
          </Typography>
        </Box>
      </Paper>

      <Paper
        elevation={2}
        sx={{
          mt: 3,
          p: 3,
          background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
          textAlign: 'center'
        }}
      >
        <Typography variant="h6" gutterBottom fontWeight="bold">
          💡 А пока используйте Дашборд
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Основная аналитика и статистика доступны в разделе <strong>"Дашборд"</strong> в главном меню.
          Там вы найдете все текущие графики, метрики и отчеты по вашему бизнесу.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Analytics;